import { createContext } from 'react';

import type { Orientation } from '../../../../../core/types/orientation.js';
import { ORIENTATION } from '../../../constants.js';

export const ChartLayoutOrientationContext = createContext<{
  orientation: Orientation;
}>({
  orientation: ORIENTATION.Vertical,
});

ChartLayoutOrientationContext['displayName'] = 'ChartLayoutOrientationContext';
